export { ContactInformationType } from './generated/ContactInformationType.js';